<template>
  <section id="hero" class="relative h-screen pt-[50px]" style="background-image: url('https://nocnoc.app/img/banner.jpg');background-size:cover;background-repeat: no-repeat;">
    <div class="container px-6 pt-16 mx-auto text-center">
        <div class="w-full max-w-2xl mx-auto animate__animated animate__fadeInUp">
            <h1 class="mb-8 text-3xl font-thin !leading-[1.208] text-white sm:text-[42px] lg:text-[40px] xl:text-4xl">
              <div class="logo_home_page">
                <img src="/img/logo.png" alt="logo" class="w-full">
              </div>
              EL MEJOR <span class="font-extrabold">ALIADO</span><br>DE TU<span class="font-extrabold"> RESTAURANTE.</span>
            </h1>

            
        </div>

        <div class="flex justify-center animate__animated animate__fadeInUp">
            <img class="object-cover w-full h-auto rounded-xl xl:w-3/5" src="/img/devices.png">
        </div>
    </div>

    <div class="container w-full mx-auto flex justify-center">
        <div class="mousey absolute bottom-8">
            <div class="scroller"></div>
        </div>
    </div>
</section>
<section id="why_noc_noc" class="overflow-hidden bg-white px-4 pb-12 pt-20 lg:pb-90px lg:pt-120px">
    <div class="container mx-auto">
        <div class="-mx-4 flex flex-wrap items-center justify-between">
            <div class="w-full px-4 lg:w-6/12">
                <div class="-mx-3 flex items-center sm:-mx-4">
                    <div class="w-full px-3 sm:px-4 xl:w-1/2">
                        <div class="py-3 sm:py-4 mb-12">
                            <img src="/img/qr_code.jpg" alt="" class="w-full shadow-2xl rounded-2xl rotate-2">
                        </div>

                        <div class="py-3 sm:py-4">
                            <img src="/img/coffee_shop.jpg" alt="" class="w-full shadow-2xl rounded-2xl -rotate-6">
                        </div>
                    </div>
                    <div class="w-full px-3 sm:px-4 xl:w-1/2">
                        <div class="relative z-10 my-4">
                            <img src="/img/waiter.jpg" alt="" class="w-full shadow-2xl rounded-2xl rotate-2">
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full px-4 lg:w-1/2 xl:w-5/12">
                <div class="mt-10 lg:mt-0">
                    <span class="mb-4 block text-lg font-semibold text-primary-500">
                        ¿Por qué noc noc?
                    </span>
                    <h2 class="mb-5 text-3xl font-bold text-neutral-700 sm:text-[40px]/[48px]">
                        Elevamos la experiencia y facilitamos la atención
                    </h2>
                    <p class="mb-5 text-base text-neutral-500">
                        noc noc te brinda un entorno completo de herramientas que te permiten llevar tu restaurante al siguiente nivel. Desde herramientas para digitalizar tu menú hasta automatizar tu proceso completo de recepción/procesado de pedidos y recolección de pagos.
                    </p>
                    <p class="mb-8 text-base text-neutral-500">
                        ¿Tienes dudas? Envíanos un mensaje y con gusto te orientaremos en el proceso.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<section id="services" class="pb-12 pt-20 px-4 lg:pb-[25px] lg:pt-[120px]">
    <div class="container mx-auto">
        <div class="-mx-4 flex flex-wrap">
            <div class="w-full px-4">
                <div class="mx-auto mb-12 max-w-[510px] text-center lg:mb-20">
                    <h2 class="mb-3 text-3xl font-bold leading-[1.2] text-neutral-700 sm:text-4xl md:text-[40px]">
                        Algunos <span class="text-primary-500">Beneficios</span>
                    </h2>
                    <p class="text-base text-neutral-500">
                        noc noc te brinda herramientas para cada necesidad en tu restaurante. ¡Si no la tenemos, la creamos para ti!
                    </p>
                </div>
            </div>
        </div>
        <div class="-mx-4 flex flex-wrap">
            <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                <div class="mb-9 rounded-[20px] bg-white h-[325px] p-10 shadow-2 hover:shadow-lg md:px-7 xl:px-10">
                    <div class="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-primary-500">
                        <span class="text-5xl text-white">
                            <i class="fa-solid fa-map-location-dot" aria-hidden="true"></i>
                        </span>
                    </div>
                    <h4 class="mb-[14px] text-2xl font-semibold text-neutral-700">
                        Sucursales
                    </h4>
                    <p class="text-neutral-500">
                        Todas las sucursales en la misma plataforma. Gestiona cada sucursal conforme tus preferencias.
                    </p>
                </div>
            </div>
            <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                <div class="mb-9 rounded-[20px] bg-white h-[325px] p-10 shadow-2 hover:shadow-lg md:px-7 xl:px-10">
                    <div class="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-primary-500">
                        <span class="text-5xl text-white">
                            <i class="fa-solid fa-book-open-reader" aria-hidden="true"></i>
                        </span>
                    </div>
                    <h4 class="mb-[14px] text-2xl font-semibold text-neutral-700">
                        Menú Digital
                    </h4>
                    <p class="text-neutral-500">
                        Digitalizar el menú es el punto de partida para automatizar tu restaurante.
                    </p>
                </div>
            </div>
            <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                <div class="mb-9 rounded-[20px] bg-white h-[325px] p-10 shadow-2 hover:shadow-lg md:px-7 xl:px-10">
                    <div class="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-primary-500">
                        <span class="text-5xl text-white">
                            <i class="fa-solid fa-qrcode" aria-hidden="true"></i>
                        </span>
                    </div>
                    <h4 class="mb-[14px] text-2xl font-semibold text-neutral-700">
                        Códigos QR
                    </h4>
                    <p class="text-neutral-500">
                        Implementa códigos QR para que tus clientes vean el menú, accedan a la conexión wifi y mucho más.
                    </p>
                </div>
            </div>
            <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                <div class="mb-9 rounded-[20px] bg-white h-[325px] p-10 shadow-2 hover:shadow-lg md:px-7 xl:px-10">
                    <div class="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-primary-500">
                        <span class="text-5xl text-white">
                            <i class="fa-solid fa-gauge" aria-hidden="true"></i>
                        </span>
                    </div>
                    <h4 class="mb-[14px] text-2xl font-semibold text-neutral-700">
                        Monitor de Pedidos
                    </h4>
                    <p class="text-neutral-500">
                        Gestión de pedidos en tiempo real. Permite a cocina ver de forma automática los pedidos nuevos.
                    </p>
                </div>
            </div>
            <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                <div class="mb-9 rounded-[20px] bg-white h-[325px] p-10 shadow-2 hover:shadow-lg md:px-7 xl:px-10">
                    <div class="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-primary-500">
                        <span class="text-5xl text-white">
                            <i class="fa-solid fa-list-check" aria-hidden="true"></i>
                        </span>
                    </div>
                    <h4 class="mb-[14px] text-2xl font-semibold text-neutral-700">
                        Tareas Recurrentes
                    </h4>
                    <p class="text-neutral-500">
                        Asegúrate que todos los colaboradores completen sus tareas recurrentes en el tiempo asignado.
                    </p>
                </div>
            </div>
            <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                <div class="mb-9 rounded-[20px] bg-white h-[325px] p-10 shadow-2 hover:shadow-lg md:px-7 xl:px-10">
                    <div class="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-primary-500">
                        <span class="text-5xl text-white">
                            <i class="fa-solid fa-book" aria-hidden="true"></i>
                    </span></div>
                    <h4 class="mb-[14px] text-2xl font-semibold text-neutral-700">
                        Reportes
                    </h4>
                    <p class="text-neutral-500">
                        Consultar tus datos nunca fue más fácil. Agiliza la toma de decisiones con los reportes que necesites.
                    </p>
                </div>
            </div>
            <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                <div class="mb-9 rounded-[20px] bg-white h-[325px] p-10 shadow-2 hover:shadow-lg md:px-7 xl:px-10">
                    <div class="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-primary-500">
                        <span class="text-5xl text-white">
                            <i class="fa-solid fa-file-invoice" aria-hidden="true"></i>
                        </span>
                    </div>
                    <h4 class="mb-[14px] text-2xl font-semibold text-neutral-700">
                        Facturación
                    </h4>
                    <p class="text-neutral-500">
                        Personaliza tu plantilla de facturas. Ahora, además de impresas, se pueden compartir por correo.
                    </p>
                </div>
            </div>
            <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                <div class="mb-9 rounded-[20px] bg-white h-[325px] p-10 shadow-2 hover:shadow-lg md:px-7 xl:px-10">
                    <div class="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-primary-500">
                        <span class="text-5xl text-white">
                            <i class="fa-solid fa-shield-halved" aria-hidden="true"></i>
                        </span>
                    </div>
                    <h4 class="mb-[14px] text-2xl font-semibold text-neutral-700">
                        Permisos de Acceso
                    </h4>
                    <p class="text-neutral-500">
                        Roles que se ajusten a la medida, dando únicamente los permisos necesarios para cada colaborador.
                    </p>
                </div>
            </div>

        </div>
    </div>
</section>


</template>
<script>
</script>